/**
 * Format an INR amount using Indian lakhs/crores notation.
 *
 *   1500            -> "₹1,500"
 *   45000           -> "₹45,000"
 *   8500000         -> "₹85 L"
 *   15000000        -> "₹1.5 Cr"
 *   12345678        -> "₹1.23 Cr"
 *
 * For rent listings, pass { monthly: true } to append "/month".
 */
export function formatInr(amount, { monthly = false, compact = true } = {}) {
  if (amount == null) return "";
  const n = Number(amount);
  if (Number.isNaN(n) || n <= 0) return "₹0" + (monthly ? "/month" : "");

  if (!compact) {
    return "₹" + n.toLocaleString("en-IN") + (monthly ? "/month" : "");
  }

  if (n >= 1_00_00_000) {
    // ≥ 1 Cr
    const cr = n / 1_00_00_000;
    const fmt =
      cr >= 10
        ? cr.toFixed(0)
        : cr % 1 === 0
        ? cr.toFixed(0)
        : cr.toFixed(2).replace(/\.?0+$/, "");
    return `₹${fmt} Cr` + (monthly ? "/month" : "");
  }
  if (n >= 1_00_000) {
    // ≥ 1 L
    const lakh = n / 1_00_000;
    const fmt =
      lakh >= 100
        ? lakh.toFixed(0)
        : lakh % 1 === 0
        ? lakh.toFixed(0)
        : lakh.toFixed(2).replace(/\.?0+$/, "");
    return `₹${fmt} L` + (monthly ? "/month" : "");
  }
  return "₹" + n.toLocaleString("en-IN") + (monthly ? "/month" : "");
}

export function pricePerSqft(price, sqft) {
  if (!price || !sqft || sqft <= 0) return null;
  const v = Math.round(price / sqft);
  return "₹" + v.toLocaleString("en-IN") + "/sqft";
}
